import { Component, Inject, OnInit } from '@angular/core';
import { ContextService } from '../services/context/context.service';
import { GoalAnalysisService } from '../services/goal-analysis.service';
import { Router } from '@angular/router';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as fromModel from '../services/models/';
import { DataService } from '../services/context/data.service';
import { RefDataService } from '../services/context/ref-data.service';
import { ReferenceService } from '../services/reference/reference.service';
import { UIStateService } from '../services/context/uistate.service';
import { Utils } from '../../utils/utils';

@Component({
  selector: 'gp-create-plan',
  templateUrl: './create-plan.component.html',
  styleUrls: ['./create-plan.component.scss']
})
export class CreatePlanComponent implements OnInit {

  
  inFlightPlan: fromModel.Plan;
  isProfileValid=false;
  isCreatePlanClicked = false;

  constructor(private contextService: ContextService,
              private dataService: DataService,
              private refDataService: RefDataService,
              private referenceService: ReferenceService,
              private uiStateService: UIStateService, 
              private goalAnalysisService: GoalAnalysisService,
              private router: Router,
              private dialogRef: MatDialogRef<CreatePlanComponent>,
              @Inject(MAT_DIALOG_DATA) private inputData: any) { }

  ngOnInit(): void {
    //this.inFlightPlan = this.inputData;
    this.createInFlightPlan();    
  }

  createInFlightPlan(){
    let planClients = this.preparePlanClients();

    this.inFlightPlan = {
      id: ' ',
      planName: `Plan for ${this.contextService.context.LegalEntityName}`,
      planType: fromModel.PLANTYPE.Base,
      //planStatus: fromModel.PLANSTATUS.Active,      
      planClients: planClients,
      planAccounts: this.preparePlanAccounts(planClients),      
      planLiabilities: this.preparePlanLiabilities(planClients),      
      goals: this.prepareGoals(),
      expenses: [],
      incomes: [],
      //incomes: this.prepareIncomes(planClients[0]),      
      // startYr: 2020,
      // endYr: 2030,      
      currentAlloc: null,
      targetAlloc: this.prepareTargetAllocation()
    };
    //this.prepareSettings();    
  }

  // prepareSettings(){
  //   let settings: fromModel.CodeValue[] = [];
  //   this.referenceService.getSettingsRefrenceData().subscribe(settingsRef =>{
  //     settings = <fromModel.CodeValue[]>settingsRef;   
  //     this.inFlightPlan.settings = settings;  
  //   });      
  // }

  preparePlanClients(){
    let planClients: fromModel.PlanClient[] = [];
    let _c: fromModel.PlanClient; 
    this.contextService.context.Clients.forEach(cl => {
      _c = {
        clientid: cl.clientid,
        clientname: cl.clientname,
        dob: cl.dob,
        age: cl.age,
        endAge: 90,
        gender: cl.gender,
        stateOfResi: cl.stateOfResi,
        role: cl.role,
        retAge: cl.retAge,  
        isIncluded: true    
      }
      planClients.push(_c);
    }); 
    return planClients;
  }

  preparePlanAccounts(planClients: fromModel.PlanClient[]){
    let planAccounts: fromModel.PlanAccount[] = [];
    let _a: fromModel.PlanAccount; 
    this.contextService.context.SelectedAccounts.forEach(ac => {
      _a = {
        actNo: ac,
        clientid: planClients[0].clientid,
        isIncluded: true 
      }
      planAccounts.push(_a);
    }); 

    return planAccounts;
  }

  preparePlanLiabilities(planClients: fromModel.PlanClient[]){
    let planLiabilities: fromModel.PlanLiability[] = [];
    let _a: fromModel.PlanAccount; 
    this.contextService.context.SelectedLiabilities.forEach(ac => {
      _a = {
        actNo: ac,
        clientid: planClients[0].clientid,
        isIncluded: true 
      }
      planLiabilities.push(_a);
    }); 

    return planLiabilities;
  }

  prepareGoals(){
    let goals: fromModel.Goal[] = [];
    goals.push(this.prepareGoal(fromModel.GOALTYPE.LIV));
    // goals.push(this.prepareGoal(fromModel.GOALTYPE.PAS));
    // goals.push(this.prepareGoal(fromModel.GOALTYPE.FAM));
    // goals.push(this.prepareGoal(fromModel.GOALTYPE.LGY));
    // goals.push(this.prepareGoal(fromModel.GOALTYPE.COM));
    return goals;
  }

  prepareGoal(goalType: fromModel.GOALTYPE){
    let goal: fromModel.Goal = { 
      "goalId": Utils.newGuidByType(fromModel.GUIDTYPE.RCMGOAL),
      "goalType": goalType,
      "goalDesc": this.refDataService.getPlanningUIRefDataByTypeCode(fromModel.PLANNINGUIREFTYPE.Goals, goalType).value,
      "priority": Number(this.refDataService.getPlanningUIRefDataByTypeCode(fromModel.PLANNINGUIREFTYPE.GoalsPriority, goalType).value),
      //"goalDesc": this.refDataService.getPlanningUIRefDataByType(fromModel.PLANNINGUIREFTYPE.Goals).find(goals=>goals.code===goalType).value,
      "isIncluded": true,
      "expenses": []
    };    
    return goal;
  }

  // prepareIncomes(client: fromModel.PlanClient){
  //   let incomes: fromModel.Income[] = [];
  //   //incomes.push(this.prepareIncome(fromModel.INCOMETYPE.EI, client));
  //   // incomes.push(this.prepareIncome(fromModel.INCOMETYPE.IN));
  //   incomes.push(this.prepareIncome(fromModel.INCOMETYPE.SS, client));
  //   // incomes.push(this.prepareIncome(fromModel.INCOMETYPE.PA));
  //   // incomes.push(this.prepareIncome(fromModel.INCOMETYPE.AN));
  //   // incomes.push(this.prepareIncome(fromModel.INCOMETYPE.OT));
  //   return incomes;
  // }

  prepareSSIncome(incomeType: fromModel.INCOMETYPE, client: fromModel.PlanClient){
    let income: fromModel.Income = null;
    income = { 
      "incId": Utils.newGuidByType(fromModel.GUIDTYPE.RCMINC),
      "incType": incomeType,
      "incDesc":this.refDataService.getPlanningUIRefDataByTypeCode(fromModel.PLANNINGUIREFTYPE.Incomes, incomeType).value,
      "owner": client.clientid,
      "growthType": fromModel.GROWTHTYPE.INF,      
      "amtPeriod": [
        {
          "startType": fromModel.AMOUNTPERIODTYPE.Age,
          "startAge": fromModel.DEFAULTS.ssStart,
          "amount": fromModel.DEFAULTS.ssAmount,
          "endType": fromModel.AMOUNTPERIODTYPE.AtEnd,
        }
      ],
      isMonthly: false,
      ssBenefitType: fromModel.SSBENEFITTYPE.MANUAL,  
      isTaxable: true,
      isAdjToFutureDollar: true,
      isIncluded: true
    };
    return income;
  }

  prepareEmploymentIncome(incomeType: fromModel.INCOMETYPE, client: fromModel.PlanClient){
    let income: fromModel.Income = null;
    let incDesc  = `${this.refDataService.getPlanningUIRefDataByTypeCode(fromModel.PLANNINGUIREFTYPE.Incomes, incomeType).value} Income`;
    let isMonthly = false;
    
    income = { 
      "incId": Utils.newGuidByType(fromModel.GUIDTYPE.RCMINC),
      "incType": incomeType,
      "incDesc":incDesc,
      "owner": client.clientid,
      "growthType": fromModel.GROWTHTYPE.INF,
      "amtPeriod": [
        {
          "startType": fromModel.AMOUNTPERIODTYPE.Year,
          "startYr": new Date().getFullYear(),
          "amount": client.salary,
          "endType": fromModel.AMOUNTPERIODTYPE.AtRet          
        }
      ],
      isMonthly: isMonthly,      
      isTaxable: true,
      isAdjToFutureDollar: true,
      isIncluded: true
    };   
    
    return income;
  }


  prepareTargetAllocation(){
    let targetAlloc: fromModel.Model = {
      "modelType": fromModel.MODELTYPE.CURRENT, // NULL, MANAGED, CUSTOM, FIRM, CURRENT 
      "modelId": null,
      "allocations": null
    };

    return targetAlloc;
  }

  private preparePlanExpense(expenseType: fromModel.EXPENSETYPE, client: fromModel.PlanClient, value, growthRate){

    let startYear = new Date().getFullYear();
    let endYear = startYear + (this.refDataService.getLifeExpectancyForClient(client.age, client.gender, fromModel.HEALTHCONDITION.Average, fromModel.SMOKER.N).endAge - client.age);
    let expense = {
      "expId": Utils.newGuidByType(fromModel.GUIDTYPE.RCMEXP),
      "expType": expenseType,
      "expDesc": this.refDataService.getPlanningUIRefDataByTypeCode(fromModel.PLANNINGUIREFTYPE.Expenses, expenseType).value,
      "owner": client.clientid,
      "growthType": fromModel.GROWTHTYPE.MNF,
      "growthRate": (growthRate*100).toFixed(2),
      "amtPeriod": [
       {
          "startType": fromModel.AMOUNTPERIODTYPE.Year, //Year, AtRet, Age
          "startYr": startYear,
          // "startAge": 0,
          "amount": value,
          "endType": fromModel.AMOUNTPERIODTYPE.AtEnd, //Year, AtRet, Age, AtEnd
          //"endYr": endYear,
          // "endAge": 0
        }
      ], 
      "isIncluded": true
    }; 

    return expense;
  }
  
  onValidateProfile(profiles: fromModel.PlanClient[]){
    if(profiles && profiles.length>0){

      this.isProfileValid = true;

    } else {
      this.isProfileValid = false;
    }
  }

  createPlan(){
    this.isCreatePlanClicked = true;
    let defaultStateExps = [];
    let defaultExp;
    let expense;
    let state;
    let endAge;
    let primaryClient: fromModel.PlanClient;
    if(this.inFlightPlan && this.inFlightPlan.planClients && this.inFlightPlan.planClients.length>0){
      
      primaryClient = this.inFlightPlan.planClients.find(pCl=> pCl.role === fromModel.CLIENTROLE.Primary);
      if(primaryClient && primaryClient.stateOfResi){
        state = primaryClient.stateOfResi;
      }

      this.inFlightPlan.planClients.forEach(cl => {
        endAge = this.refDataService.getLifeExpectancyForClient(cl.age, cl.gender, fromModel.HEALTHCONDITION.Average, fromModel.SMOKER.N).endAge;        
        cl.endAge = endAge;
        cl.salary =  Utils.getNumber(cl.salary);

        this.inFlightPlan.incomes.push(this.prepareSSIncome(fromModel.INCOMETYPE.SS, cl));

        
        if(cl.empType === fromModel.EMPLOYMENTTYPE.EMP){
          this.inFlightPlan.incomes.push(this.prepareEmploymentIncome(fromModel.INCOMETYPE.EI, cl));
        } else if(cl.empType === fromModel.EMPLOYMENTTYPE.SEMP){
          this.inFlightPlan.incomes.push(this.prepareEmploymentIncome(fromModel.INCOMETYPE.SE, cl));
        }          
      });
      
    }

    this.referenceService.getDefaultExpenseReferenceDataAPI(state).subscribe(refData=>{
      if(refData) {
        defaultStateExps = <[]>refData;
        if(defaultStateExps && defaultStateExps.length>0){

          if(primaryClient.empType === fromModel.EMPLOYMENTTYPE.RET){
            defaultExp = defaultStateExps[0];  
          } else {
            const _defaultExps = defaultStateExps.filter(({ minSalary, maxSalary }) => primaryClient.salary>=minSalary && primaryClient.salary<= maxSalary);                      

            if(_defaultExps.length>0){
              defaultExp = _defaultExps[0];
            } else {
              defaultExp = defaultStateExps[0];
            }
          } 
          
          expense = this.preparePlanExpense(fromModel.EXPENSETYPE.HSG, primaryClient, defaultExp[fromModel.EXPENSETYPE.HSG], defaultExp['HSG_INF']);
          this.inFlightPlan.expenses.push(expense);
          
          expense = this.preparePlanExpense(fromModel.EXPENSETYPE.TPT, primaryClient, defaultExp[fromModel.EXPENSETYPE.TPT], defaultExp['TPT_INF']);
          this.inFlightPlan.expenses.push(expense);

          expense = this.preparePlanExpense(fromModel.EXPENSETYPE.HLC, primaryClient, defaultExp[fromModel.EXPENSETYPE.HLC], defaultExp['HLC_INF']);
          this.inFlightPlan.expenses.push(expense);

          expense = this.preparePlanExpense(fromModel.EXPENSETYPE.INP, primaryClient, defaultExp[fromModel.EXPENSETYPE.INP], defaultExp['INP_INF']);
          this.inFlightPlan.expenses.push(expense);

          expense = this.preparePlanExpense(fromModel.EXPENSETYPE.PE, primaryClient, defaultExp[fromModel.EXPENSETYPE.PE], defaultExp['PE_INF']);
          this.inFlightPlan.expenses.push(expense);

          expense = this.preparePlanExpense(fromModel.EXPENSETYPE.GRC, primaryClient, defaultExp[fromModel.EXPENSETYPE.GRC], defaultExp['GRC_INF']);
          this.inFlightPlan.expenses.push(expense);

          expense = this.preparePlanExpense(fromModel.EXPENSETYPE.FD, primaryClient, defaultExp[fromModel.EXPENSETYPE.FD], defaultExp['FD_INF']);
          this.inFlightPlan.expenses.push(expense);

          expense = this.preparePlanExpense(fromModel.EXPENSETYPE.TRL, primaryClient, defaultExp[fromModel.EXPENSETYPE.TRL], defaultExp['TRL_INF']);
          this.inFlightPlan.expenses.push(expense);

          expense = this.preparePlanExpense(fromModel.EXPENSETYPE.ENT, primaryClient, defaultExp[fromModel.EXPENSETYPE.ENT], defaultExp['ENT_INF']);
          this.inFlightPlan.expenses.push(expense);
        }
      }
      this.prepareGoalExpenses(fromModel.GOALTYPE.LIV, this.inFlightPlan.expenses);
      this.contextService.dispatchAction(fromModel.APP_ACTION.INFLIGHTPLAN,"CreatePlanComponent - createPlan", this.inFlightPlan);      
      this.dataService.dispatchAction(fromModel.DATA_ACTION.INFLIGHTPLAN,"CreatePlanComponent - createPlan", this.inFlightPlan);      
      //this.dataService.dispatchAction(fromModel.DATA_ACTION.ACCOUNTS,"CreatePlanComponent - updateContextWithSecClient", null);
      
      this.closeDialog(this.inFlightPlan);
      this.isCreatePlanClicked = false;
    });         
  }

  private prepareGoalExpenses(goalType: fromModel.GOALTYPE, expenses: fromModel.Expense[]){
    let _goal = this.inFlightPlan.goals.find(goal=> goal.goalType === goalType);
    if(_goal){
      let _goalPosition = this.inFlightPlan.goals.indexOf(_goal);
      if(expenses && expenses.length>0){
        expenses.forEach(exp => {
          this.inFlightPlan.goals[_goalPosition].expenses.push(exp.expId);
        });      
      }          
    }    
  }

  cancelCreatePlan(){
    this.closeDialog();
    this.router.navigate(['/home']);
  }

  closeDialog(inFlightPlan?): void {
    this.dialogRef.close(inFlightPlan);
    //this.router.navigate(['/home']);
  }
}
